import {createMapStore} from '@repo/shared-web/lib/map_data_store';

const nzbDownloadLinkStore = createMapStore<string, string>();

export const useAllNzbDownloadLink = nzbDownloadLinkStore.useAllData;
export const useNzbDownloadLink = nzbDownloadLinkStore.useData;
export const setNzbDownloadLink = nzbDownloadLinkStore.setData;
